//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

//store
import store from "@/components/store/index.js";

//引用页面
import box from '@/views/box/index.vue';
import team from '@/views/team/index.vue';

//定义routes路由的集合，数组类型
const routes=[
    //单个路由均为对象类型，path代表的是路径，component代表组件
    {path:'/index',name : 'index',component:box},
    {path:'/team',name : 'team',component:team},
    // {path:'/role',name : 'role',component:role, meta:{auth: true}},
    {path:"",redirect: '/index'}   
]

//实例化VueRouter并将routes添加进去
const router = new VueRouter({
//ES6简写，等于routes：routes
    routes,
});

// 路由守卫
router.beforeEach((to,from,next)=>{
    // to要跳转到的路径
    // from从哪个路径来
    // next往下执行的回调
    // 在localStorage中获取token
    let token = localStorage.getItem('token')
    // 判断该页面是否需要登录
    if(to.meta.auth){
        // 如果token存在直接跳转
        if(token && store.state.userinfo.zid){
            next()
        }else{
            next()
            // 否则跳转到login登录页面
            // next({
            //     path:'/cover',
            //     // 跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
            //     query:{
            //         redirect:to.fullPath
            //     }
            // })
        }
    }else{
        // 如果不需要登录，则直接跳转到对应页面
        next()
    }
})

//抛出这个这个实例对象方便外部读取以及访问
export default router